module.exports = __webpack_public_path__ + "static/media/JosefinSans-Thin.2e276f49.ttf";